import { nils } from "../../utils/utils.jsx";
import { ethers } from "ethers";
import erc20_abi from "./abis/ERC20base.json";
import erc721_abi from "./abis/ERC721base.json";
import skins_extra_abi from "./abis/DNA_Skins_extraabi.json";
import { contractAddress_list } from "../contracts.jsx";

const get_erc20_parsed_logs = (logs) => {
  const iface = new ethers.Interface(erc20_abi);
  let parsed_logs = [];
  for (let log of logs) {
    try {
      let par = iface.parseLog(log);
      if (nils(par)) continue;
      parsed_logs.push(par);
    } catch (err) {}
  }
  return parsed_logs;
};

const get_erc721_parsed_logs = (logs) => {
  const iface = new ethers.Interface(erc721_abi);
  let parsed_logs = [];
  for (let log of logs) {
    try {
      let par = iface.parseLog(log);
      if (nils(par)) continue;

      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;
      o.args = par.args;
      if (o.name == "Transfer") {
        o.name = "ERC721Transfer";
        o.args = {
          from: o.args[0].toLowerCase(),
          to: o.args[1].toLowerCase(),
          token_id: Number(o.args[2]),
        };

        parsed_logs.push(o);
      }
    } catch (err) {}
  }
  return parsed_logs;
};

const skins_rvmode_addrmap = {
  bike: contractAddress_list.baseskinsbike,
  car: contractAddress_list.baseskinscar,
  horse: contractAddress_list.baseskinshorse,
};

const rev_skins_rvmode_addrmap = {};
for (let [mode, addr] of Object.entries(skins_rvmode_addrmap)) {
  if (addr) {
    rev_skins_rvmode_addrmap[addr.toLowerCase()] = mode;
  }
}

// Separate function to parse base skin contract events (exportable)
const parse_base_skin_events = (logs) => {
  if (!logs) return [];

  const iface = new ethers.Interface(skins_extra_abi);
  let logrows = [];

  for (let log of logs) {
    try {
      let par = iface.parseLog(log);
      if (nils(par)) continue;

      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
        address: log.address.toLowerCase(),
      };
      o.id = `${o.hash}:${o.logIndex}`;

      // event SkinMinted(uint256 skinid, string name, string rarity)
      if (name == "SkinMinted") {
        let address = o.address;
        let rvmode = rev_skins_rvmode_addrmap[address] ?? null;
        let a = par.args;
        o.args = {
          skinid: Number(a[0]),
          name: a[1],
          rarity: a[2],
          rvmode,
        };
        o.args.rvsid = `${rvmode}-${o.args.skinid}`;
      }

      logrows.push(o);
    } catch (err) {
      // Skip logs that don't match our ABI
      continue;
    }
  }
  return logrows;
};

const get_logs_parser = {
  erc20: get_erc20_parsed_logs,
  erc721: get_erc721_parsed_logs,
  base_skin: parse_base_skin_events,
};

export default get_logs_parser;
export { skins_rvmode_addrmap };
